// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconPlaceholderPath = 'm22.48 23.043-6.242-8.104 6.186-8.032C24.616 8.919 26 11.798 26 15c0 3.176-1.36 6.033-3.52 8.043ZM9.066 24.248l5.91-7.671 5.923 7.692a10.925 10.925 0 0 1-11.833-.021ZM4 15c0-3.188 1.372-6.056 3.546-8.066l6.167 8.005-6.222 8.077c-2.143-2.008-3.49-4.854-3.49-8.016Zm16.835-9.308-5.86 7.609L9.13 5.713A10.92 10.92 0 0 1 15 4c2.145 0 4.142.627 5.835 1.692ZM15 2C7.832 2 2 7.832 2 15s5.831 13 13 13 13-5.832 13-13S22.17 2 15 2Z';
var NavigationIconPlaceholder = baseIcon('NavigationIconPlaceholder', {
  getPath: () => NavigationIconPlaceholderPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconPlaceholder;
//# sourceMappingURL=index.js.map